import {
  put, takeEvery, all, call,
} from 'redux-saga/effects';
import SearchListApi from './search-list.api';
import ErrorFormatService from '../../../services/error-format-service';
import {
  GET_LIST_CONTACT_DATA, GET_LIST_CONTACT_DATA_SUCCESS, GET_LIST_CONTACT_DATA_ERROR,
  GET_LIST_CONTACT_PERSON_DATA, GET_LIST_CONTACT_PERSON_DATA_SUCCESS, GET_LIST_CONTACT_PERSON_DATA_ERROR,
  GET_LIST_CONTACT_COMPANY_DATA, GET_LIST_CONTACT_COMPANY_DATA_SUCCESS, GET_LIST_CONTACT_COMPANY_DATA_ERROR,
  GET_LIST_CONTACT_PERSON_INTERNAL_DATA, GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS,
  GET_LIST_CONTACT_PERSON_INTERNAL_DATA_ERROR, GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA,
  GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_SUCCESS, GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_ERROR,
  GET_LIST_NOT_LINKED_USER_DATA, GET_LIST_NOT_LINKED_USER_DATA_SUCCESS, GET_LIST_NOT_LINKED_USER_DATA_ERROR,
  GET_LIST_DEAL_DATA, GET_LIST_DEAL_DATA_SUCCESS, GET_LIST_DEAL_DATA_ERROR,
  GET_LIST_ACTIVITY_DEAL_DATA, GET_LIST_ACTIVITY_DEAL_DATA_SUCCESS, GET_LIST_ACTIVITY_DEAL_DATA_ERROR,
  GET_LIST_DEAL_ASSET_DATA, GET_LIST_DEAL_ASSET_DATA_SUCCESS, GET_LIST_DEAL_ASSET_DATA_ERROR,
  GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_SUCCESS, GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_ERROR,
  GET_LIST_CONTACT_NOT_PARTICIPANT_DATA,
  GET_LIST_TAG_DATA, GET_LIST_TAG_DATA_SUCCESS, GET_LIST_TAG_DATA_ERROR,
} from '../../../constants/system/actions';

export function* getListContactData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListContactData, payload);
    yield put({ type: GET_LIST_CONTACT_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_CONTACT_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListContactPersonData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListContactPersonData, payload);
    yield put({ type: GET_LIST_CONTACT_PERSON_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_CONTACT_PERSON_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListContactCompanyData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListContactCompanyData, payload);
    yield put({ type: GET_LIST_CONTACT_COMPANY_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_CONTACT_COMPANY_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListContactPersonInternalData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListContactPersonInternalData, payload);
    yield put({ type: GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_CONTACT_PERSON_INTERNAL_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListContactNotParticipantData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListContactNotParticipantData, payload);
    yield put({ type: GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListDealTaskContactPersonData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListDealTaskContactPersonData, payload);
    yield put({ type: GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListNotLinkedUserData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListNotLinkedUserData, payload);
    yield put({ type: GET_LIST_NOT_LINKED_USER_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_NOT_LINKED_USER_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListDealData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListDealData, payload);
    yield put({ type: GET_LIST_DEAL_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_DEAL_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListActivityDealData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListActivityDealData, payload);
    yield put({ type: GET_LIST_ACTIVITY_DEAL_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_ACTIVITY_DEAL_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListDealAssetData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListDealAssetData, payload);
    yield put({ type: GET_LIST_DEAL_ASSET_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_DEAL_ASSET_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* getListTagData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SearchListApi.getListTagData, payload);
    yield put({ type: GET_LIST_TAG_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_LIST_TAG_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export default function* searchListSagas(): Generator<ReduxAction> {
  yield all([
    takeEvery(GET_LIST_CONTACT_DATA, getListContactData),
    takeEvery(GET_LIST_CONTACT_PERSON_DATA, getListContactPersonData),
    takeEvery(GET_LIST_CONTACT_COMPANY_DATA, getListContactCompanyData),
    takeEvery(GET_LIST_CONTACT_PERSON_INTERNAL_DATA, getListContactPersonInternalData),
    takeEvery(GET_LIST_CONTACT_NOT_PARTICIPANT_DATA, getListContactNotParticipantData),
    takeEvery(GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA, getListDealTaskContactPersonData),
    takeEvery(GET_LIST_NOT_LINKED_USER_DATA, getListNotLinkedUserData),
    takeEvery(GET_LIST_DEAL_DATA, getListDealData),
    takeEvery(GET_LIST_ACTIVITY_DEAL_DATA, getListActivityDealData),
    takeEvery(GET_LIST_DEAL_ASSET_DATA, getListDealAssetData),
    takeEvery(GET_LIST_TAG_DATA, getListTagData),
  ]);
}
